<app-home-layout [isSearch]="true" *ngIf="isSearch"></app-home-layout>
<app-sidebar [isSearch]="true" *ngIf="!isSearch"></app-sidebar>